export default "__VITE_ASSET__Dx63$u$C__"